import { defineComponent as te, useCssVars as oe, ref as a, onMounted as ne, onUnmounted as re, computed as m, watch as W, nextTick as ie, openBlock as o, createElementBlock as i, createElementVNode as w, renderSlot as b, createVNode as M, unref as p, withCtx as le, createTextVNode as ae, toDisplayString as h, normalizeClass as v, normalizeStyle as se, createCommentVNode as f, Fragment as F, renderList as P, createBlock as g } from "vue";
import de from "./novoui-vuejs2.js";
import "./novoui-vuejs3.js";
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs80.js";
import "./novoui-vuejs9.js";
import L from "./novoui-vuejs10.js";
import ce from "./novoui-vuejs11.js";
import "./novoui-vuejs12.js";
import "./novoui-vuejs13.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import ue from "./novoui-vuejs18.js";
import "./novoui-vuejs19.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs22.js";
import "./novoui-vuejs23.js";
import pe from "./novoui-vuejs25.js";
import "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs28.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs110.js";
import "./novoui-vuejs39.js";
import "./novoui-vuejs40.js";
import "./novoui-vuejs41.js";
import { DropdownActivatorSize as ve, DropdownIndicator as C, getDropdownStyleClasses as fe, getDropdownSectionClasses as me, getDropdownDividerStyleClasses as we } from "./novoui-vuejs58.js";
const he = {
  key: 0,
  class: "dropdown-indicator"
}, ge = {
  key: 0,
  class: "dropdown-headers"
}, Ce = { class: "dropdown-headers-header" }, ye = { class: "dropdown-headers-subheader" }, ke = ["onClick"], _e = { class: "dropdown-option-label" }, lt = /* @__PURE__ */ te({
  __name: "NDropdown",
  props: {
    activatorSize: { default: ve.MEDIUM },
    closeOnContentClick: { type: Boolean, default: !0 },
    closeOnClickOutside: { type: Boolean, default: !0 },
    indicator: { default: C.LEFT },
    label: { default: "Dropdown" },
    maxHeight: { default: "100vh" },
    searchField: { type: Boolean, default: !1 },
    searchPlaceholder: { default: "Search" },
    sections: {},
    selectMode: { type: Boolean, default: !1 },
    value: { default: "" },
    width: {},
    preventWindowClipping: { type: Boolean, default: !0 },
    bordered: { type: Boolean, default: !1 }
  },
  emits: [
    /**
     * Emits relevant option data and the selecting event whenever a dropdown option is picked
     */
    "option-selected"
  ],
  setup(A, { emit: H }) {
    oe((e) => ({
      "09795fac": X.value
    }));
    const t = A, U = H, G = a(), s = a(), _ = a(), n = a(), B = a(t.value), y = a(""), c = a(!1), x = a("down"), E = a(t.indicator), k = a(), z = a();
    ne(() => {
      t.preventWindowClipping && s.value && (window.addEventListener("resize", R), s.value.style.transform = "scale(1,1)", k.value = s.value.getBoundingClientRect().width, z.value = s.value.getBoundingClientRect().height, s.value.style.transform = "");
    }), re(() => {
      t.preventWindowClipping && window.removeEventListener("resize", R);
    });
    function R(e) {
      if (s.value && n.value) {
        const l = e.target;
        x.value = I(l), E.value = D(l);
      }
    }
    function D(e) {
      return !n.value || !t.preventWindowClipping ? t.indicator : n.value.getBoundingClientRect().x < k.value - n.value.getBoundingClientRect().width && t.indicator === C.RIGHT ? C.LEFT : e.innerWidth < n.value.getBoundingClientRect().x + k.value ? n.value.getBoundingClientRect().x > k.value ? C.RIGHT : C.LEFT : t.indicator;
    }
    function I(e) {
      return !n.value || !t.preventWindowClipping ? "down" : e.innerHeight < n.value.getBoundingClientRect().y + n.value.getBoundingClientRect().height + z.value && n.value.getBoundingClientRect().y > z.value ? "up" : "down";
    }
    const X = m(() => {
      const e = t.maxHeight;
      return typeof e == "string" ? isNaN(e) ? e : `${e}px` : `${e}px`;
    }), $ = m(() => {
      const e = t.width;
      if (typeof e == "string")
        return e.trim() ? isNaN(e) ? e : `${e}px` : void 0;
      if (typeof e == "number")
        return `${e}px`;
    }), Y = m(() => {
      if ($.value !== void 0)
        return {
          "--novoui-dropdown-width": $.value
        };
    }), j = m(() => fe(t, E.value, x.value, c.value)), q = m(() => me(t)), J = m(() => {
      if (!t.sections)
        return [];
      if (!y.value)
        return t.sections;
      const e = y.value.toLowerCase();
      return t.sections.map((l) => l.options ? {
        ...l,
        options: l.options.filter((d) => d.filterValues ? d.label.toLowerCase().includes(e) || d.filterValues.some((u) => u.toLowerCase().includes(e)) : d.label.toLowerCase().includes(e))
      } : l);
    });
    W(
      () => t.value,
      (e) => {
        B.value = e;
      }
    ), W(
      () => c.value,
      (e) => {
        e ? ie(() => {
          document.addEventListener("click", T);
        }) : document.removeEventListener("click", T);
      }
    );
    function K(e, l, d) {
      U("option-selected", e, l, d), B.value = l;
    }
    function Q(e) {
      y.value = e;
    }
    function N() {
      c.value = !c.value, x.value = I(window), E.value = D(window);
    }
    const T = (e) => {
      n.value && n.value.contains(e.target) || // Click is in Activator
      _.value && _.value.contains(e.target) || (s.value && s.value.contains(e.target) ? c.value = !t.closeOnContentClick : c.value = !t.closeOnClickOutside);
    };
    return (e, l) => (o(), i("div", {
      ref_key: "dropdownContainer",
      ref: G,
      class: "dropdown-container"
    }, [
      w("div", {
        ref_key: "activatorEl",
        ref: n
      }, [
        b(e.$slots, "activator", {
          onActivate: N,
          visible: c.value
        }, () => [
          M(p(de), {
            class: "dropdown-activator",
            size: t.activatorSize,
            onClick: N,
            "data-testid": "dropdown-activator"
          }, {
            default: le(() => [
              ae(h(t.label), 1)
            ]),
            _: 1
          }, 8, ["size"])
        ], !0)
      ], 512),
      w("div", {
        ref_key: "dropdownEl",
        ref: s,
        class: v(j.value),
        style: se(Y.value),
        "data-testid": "dropdown-content"
      }, [
        t.indicator ? (o(), i("div", he)) : f("", !0),
        b(e.$slots, "content", {}, () => [
          t.searchField ? (o(), i("div", {
            key: 0,
            ref_key: "searchEl",
            ref: _
          }, [
            M(pe, {
              class: "dropdown-search",
              variant: "outline",
              hasLabel: !1,
              label: "",
              placeholder: t.searchPlaceholder,
              hasAssistiveText: !1,
              assistiveText: "",
              size: "medium",
              "model-value": y.value,
              "onUpdate:modelValue": Q
            }, null, 8, ["placeholder", "model-value"])
          ], 512)) : f("", !0),
          w("div", {
            class: v(q.value)
          }, [
            (o(!0), i(F, null, P(J.value, ({ divider: d, header: u, subHeader: S, smallHeadline: O, options: Z }, V) => (o(), i("div", {
              class: "dropdown-section",
              key: V
            }, [
              u && S ? (o(), i("div", ge, [
                w("p", Ce, h(u), 1),
                w("p", ye, h(S), 1)
              ])) : u ? (o(), i("p", {
                key: 1,
                class: v(["dropdown-header", [{ "dropdown-header-small": O }]])
              }, h(u), 3)) : S ? (o(), i("p", {
                key: 2,
                class: v(["dropdown-subheader", [{ "dropdown-header-small": O }]])
              }, h(u), 3)) : f("", !0),
              (o(!0), i(F, null, P(Z, (r) => (o(), i("button", {
                class: "dropdown-option",
                key: r.value,
                onClick: (ee) => K(ee, r.value, r)
              }, [
                b(e.$slots, "custom-option", {}, () => [
                  r.prefixIcon ? (o(), i("div", {
                    key: 0,
                    class: v(r.flag ? "dropdown-option-icon-flag" : "dropdown-option-icon")
                  }, [
                    r.flag ? (o(), g(p(ce), {
                      key: 0,
                      country: r.prefixIcon
                    }, null, 8, ["country"])) : (o(), g(p(L), {
                      key: 1,
                      icon: r.prefixIcon,
                      size: 20
                    }, null, 8, ["icon"]))
                  ], 2)) : f("", !0),
                  w("p", _e, h(r.label), 1),
                  (t.selectMode ? r.value === B.value : r.suffixIcon) ? (o(), i("div", {
                    key: 1,
                    class: v([t.selectMode ? "dropdown-option-icon-large" : "dropdown-option-icon-small", "no-fill"])
                  }, [
                    t.selectMode ? (o(), g(p(L), {
                      key: 0,
                      icon: "tick",
                      size: "normal"
                    })) : r.suffixIcon ? (o(), g(p(L), {
                      key: 1,
                      icon: r.suffixIcon,
                      size: "small"
                    }, null, 8, ["icon"])) : f("", !0)
                  ], 2)) : f("", !0)
                ], !0)
              ], 8, ke))), 128)),
              V !== (t.sections || []).length - 1 ? (o(), g(p(ue), {
                key: 3,
                class: v(["dropdown-divider", p(we)(d)])
              }, null, 8, ["class"])) : f("", !0)
            ]))), 128))
          ], 2)
        ], !0)
      ], 6)
    ], 512));
  }
});
export {
  lt as default
};
